/**
 * Corporate Theme Configuration
 *
 * Professional, polished, trust-building design.
 * Best for: SaaS products, business applications, client-facing apps
 */

import type { ThemeConfig } from '#src/errors/types';

export const corporateTheme: ThemeConfig = {
  iconSize: 'h-12 w-12',
  badgeStyle: 'rounded-full border border-border/60 bg-muted px-4 py-1.5 shadow-sm',
  headingSize: 'text-3xl font-bold sm:text-5xl',
  animation: true
} as const;
